module.exports = __webpack_public_path__ + "static/media/ico-predefin.c766dcca.svg";